module.exports = __webpack_public_path__ + "static/member-5-92f2874ba2db4bba3c36b834f6b2b59f.png";